import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { OverdueRow } from './overdue-row';
import { IOverdueTasks } from '../type';

interface Props {
  tableProps: TableProps;
  rows?: IOverdueTasks[];
  loading: boolean;
  employee?: boolean;
}

const OverdueList = ({ tableProps, rows, loading, employee }: Props) => {
  const TABLE_HEAD = [
    ...(!employee ? [{ id: 'assignee', label: 'Assignee', align: 'center', sortable: false }] : []),
    { id: 'projectName', label: 'Board Name', align: 'center', sortable: false },
    { id: 'managedBy', label: 'Managed By', align: 'center', sortable: false },
    { id: 'taskName', label: 'Task Name', align: 'center', sortable: false },
    { id: 'startDateTime', label: 'Start Date/Time', align: 'center', sortable: false },
    { id: 'endDateTime', label: 'End Date/Time', align: 'center', sortable: false },
    { id: 'completedDateTime', label: 'Completed Date/Time', align: 'center', sortable: false },
    { id: 'expectedTime', label: 'Expected Time (Hours)', align: 'center', sortable: false },
    { id: 'actualTime', label: 'Actual Time (Hours)', align: 'center', sortable: false },
  ];

  return (
    <PaginatedTable<IOverdueTasks>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => <OverdueRow row={row} employee={employee} />}
    </PaginatedTable>
  );
};

export { OverdueList };
